<template lang="pug">
.authContainer
  .authWrapper
    p.template_text(v-html='getTemplateText')
    ul.ul_text
      li пройти профориентационное тестирование
      li подать заявку на обучение по образовательной программе
      li получить рекомендации по выбору компетенции или профессии
      li оставить заявку на участие в мероприятии
      li оставить отклик на вакансию
    FormSignin.register__form(key='signin', @submit='signUp')
      FormButton.open_registration_button(
        :disabled='false',
        :rounded='true',
        size='medium',
        type='submit',
        @click='openRegistration()',
        v-html='"Зарегистрироваться"',
        slot='buttons'
      )
</template>

<script>
import FormSignup from '../default/popup/forms/signup';
import FormSignin from '../default/popup/forms/signin';
import AuthForm from '../default/popup/forms/component';
import { AUTH_TEMPLATE_TEXT } from './AuthConsts';
import FormButton from '@/components/ext/Button.vue';

export default {
  name: 'Authen',
  components: {
    FormSignin,
    FormSignup,
    AuthForm,
    FormButton,
  },
  data() {
    return {
      isSignup: true,
    };
  },
  props: {
    redirect: {
      type: String,
      default: '',
    },
  },
  methods: {
    signUp() {
      let _redirect = this.redirect;
      this.$nextTick(() => {
        this.$router.push({ name: _redirect ? _redirect : 'home' });
      });
    },
    openRegistration() {
      if (this.redirect) {
        this.$store.commit('user/setAfterRegister', true);
      }
      this.$router.push({
        name: 'auth-register',
        query: { redirect: this.redirect },
      });
    },
  },
  computed: {
    getTemplateText() {
      return AUTH_TEMPLATE_TEXT;
    },
  },
};
</script>
<style lang="stylus">
.authWrapper form
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
.authWrapper .register__form .markup-popup-form__buttons
  @media only screen and (max-width: 735px){
    flex-direction column
  }
  width: 65%;
  justify-content space-between;
  button
    @media only screen and (max-width: 735px){
      width 100%;
      margin-bottom: 7px;
    }
    width: 290px;
.authContainer .authWrapper .markup-popup-form-dashed.markup-popup-form__form
  width: 65% !important;
</style>
<style scoped lang="stylus">
.authContainer
  display flex
  justify-content center
.template_text
  text-align center
  font-size: 21px;
  padding-bottom: 27px;
.ul_text
  padding-top: 21px;
  font-size: 21px;
  padding-left: 14%;
  padding-right: 14%;
.register__form
  padding 30px
.open_registration_button
  background-color: #706dcf
.authWrapper
  @media screen and (max-width 640px)
    padding-top: 20px;
  padding-top 20px;
  max-width: 1050px;
  display flex
  flex-direction column
  width: 100%


.ul_text
  list-style: none;
  counter-reset: list;

.ul_text>li
  position: relative;
  display: block;
  height: 3rem;
  line-height: 3rem;
  margin-left: 1.75rem;
  margin-bottom: 1rem;
  padding-left: 2rem;
  padding-right: .5rem;
  //color: #fff;
  background: #e4e1e1;
  white-space: nowrap;
  border-radius: 1rem
.ul_text>li:last-child
  margin-bottom: 0
.ul_text>li::before
  content: counter(list);
  counter-increment: list;
  position: absolute;
  left: -0.8rem;
  top: 0.35rem;
  bottom: -0.25rem;
  width: 2.2rem;
  height: 2.2rem;
  line-height: 2rem;
  border-radius: 1.25rem;
  //border: .25rem solid #fff;
  text-align: center;
  color: #706dcf;
  background: #706dcf;
</style>



// WEBPACK FOOTER //
// Auth.vue?16db3021